import React, { useState, lazy, Suspense } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'
import { Flex, Grid } from 'lese'

import Card from 'Components/Card'
import CardButton from 'Components/CardButton'
import Button from 'Components/Button'
import { ModalStore } from 'Root/store'

const ErrorMessage = styled.span`
  color: #f00;
`

let StyledCalendar
import('react-calendar').then(
  ({ default: comp }) =>
    (StyledCalendar = styled(comp)`
      border: 1px solid ${colors.borderColor};
    `)
)

const ModalCard = styled(Card)`
  background: ${colors.background};
  min-width: 350px;
`

const MonthButton = styled(CardButton)`
  cursor: pointer;
  width: 100%;
  padding: 16px;
  justify-content: center;
  ${({ color }) => color && `color: ${color};`}
`

export default ({ value, onChange, onClose, color, ...props }) => {
  const updateDates = dates => {
    onChange(dates)
    setDates(dates)
  }

  const [errorText, setErrorText] = useState('')
  const [{ startDate, endDate }, setDates] = useState(value)
  const getMonthsAgo = val => {
    const startDate = new Date()
    startDate.setDate(1)
    startDate.setMonth(startDate.getMonth() - val)
    startDate.setHours(0, 0 - new Date().getTimezoneOffset(), 0, 0)

    const endDate = new Date()
    endDate.setDate(0)
    endDate.setHours(23, 59 - new Date().getTimezoneOffset(), 59, 999)
    return {
      startDate,
      endDate
    }
  }
  const getOneWeekAgo = () => {
    const today = new Date()

    const startDate = new Date()
    startDate.setHours(0, 0, 0, 0)
    startDate.setDate(today.getDate() - today.getDay() - 7)

    const endDate = new Date()
    endDate.setHours(23, 59 - new Date().getTimezoneOffset(), 59, 999)
    endDate.setDate(today.getDate() - today.getDay())
    return {
      startDate,
      endDate
    }
  }
  return (
    <ModalCard
      column
      separation="16px"
      title="Date"
      subtitle="Select"
      buttonText="Update"
      color={color}
      onClick={() => {
        if (startDate >= endDate)
          return setErrorText('The start date must be before the end date')

        if (typeof onClose === 'function') onClose({ startDate, endDate })
        ModalStore.set(({ components }) => ({
          components: components.slice(0, components.length - 1)
        }))
      }}
      {...props}
    >
      <Flex separation="8px">
        <MonthButton
          color={color}
          onClick={() => {
            updateDates(getOneWeekAgo())
          }}
        >
          Last Week
        </MonthButton>
        <MonthButton
          color={color}
          onClick={() => {
            updateDates(getMonthsAgo(1))
          }}
        >
          Last Month
        </MonthButton>
        <MonthButton color={color} onClick={() => updateDates(getMonthsAgo(3))}>
          Last 3 Months
        </MonthButton>
      </Flex>
      <Grid columns="1fr 1fr" gap="16px">
        <Flex column xAlign separation="16px">
          <p>Start Date</p>
          <Suspense>
            <StyledCalendar
              onChange={startDate => {
                startDate.setHours(0, 0, 0, 0)
                updateDates({ startDate, endDate })
              }}
              value={
                startDate instanceof Date
                  ? new Date(
                      startDate.getTime() +
                        new Date().getTimezoneOffset() * 60000
                    )
                  : undefined
              }
              showFixedNumberOfWeeks={5}
            />
          </Suspense>
        </Flex>
        <Flex column xAlign separation="16px">
          <p>End Date</p>
          <Suspense>
            <StyledCalendar
              onChange={endDate => {
                endDate.setHours(
                  23,
                  59 - new Date().getTimezoneOffset(),
                  59,
                  999
                )
                updateDates({ startDate, endDate })
              }}
              value={
                endDate instanceof Date
                  ? new Date(
                      endDate.getTime() + new Date().getTimezoneOffset() * 60000
                    )
                  : undefined
              }
              showFixedNumberOfWeeks={5}
            />
          </Suspense>
        </Flex>
      </Grid>
      {errorText && <ErrorMessage xAlignSelf>{errorText}</ErrorMessage>}
      <Button
        style={{ alignSelf: 'center' }}
        color={color}
        onClick={() => updateDates({})}
      >
        Clear Selection
      </Button>
    </ModalCard>
  )
}
